module.exports = __webpack_public_path__ + "img/save-w.409e09cc.svg";